module.exports = __webpack_public_path__ + "img/img-7.a01f0793.webp";